import { useAuthStore } from '@/stores/auth.store'
import { useModalStore } from '@/stores/modal.store'
import { usePaymentStore } from '@/stores/payment.store'
import { useConversationStore } from '@/stores/conversation.store'
import { useCallStore } from '@/stores/call.store'
import { useTranslationStore } from '@/stores/translation.store'

/**
 * Clear all Pinia stores in the application
 * This can be used during logout or when a deep reset of application state is needed
 */
export const clearStores = () => {
    console.log('Clearing all application stores...')

    // Clear auth store
    const authStore = useAuthStore()
    authStore.logoutClean()

    // Clear modal store
    const modalStore = useModalStore()
    modalStore.closeModal()

    // Clear payment store
    const paymentStore = usePaymentStore()
    paymentStore.setProcessingPayment(false)
    paymentStore.clearPaymentError()

    // Clear conversation store
    const conversationStore = useConversationStore()
    conversationStore.logoutClean()

    // Clear call store
    const callStore = useCallStore()
    try {
        // First try the explicit logoutClean method that's most appropriate
        if (typeof callStore.logoutClean === 'function') {
            callStore.logoutClean()
        }
        // Then try $reset which we've now implemented
        else if (typeof callStore.$reset === 'function') {
            callStore.$reset()
        }
        // Fallbacks for other potential methods
        else if (typeof callStore.resetStore === 'function') {
            callStore.resetStore()
        } else if (typeof callStore.endCall === 'function') {
            callStore.endCall()
        } else {
            console.warn('No suitable reset method found for call store')
        }
    } catch (error) {
        console.error('Error resetting call store:', error)
    }

    // Clear translation store
    const translationStore = useTranslationStore()
    translationStore.resetTranslationState()
    translationStore.setTranslationEnabled(false)

    console.log('All stores cleared successfully')
}
